import React, { useState } from 'react';
import ClientDropdown from './clientDropdown';

export function FranchiseeModal({
  isModalOpen,
  isEditMode,
  editFranchisee,
  handleChange,
  handleSubmit,
  handleDelete,
  handleCloseModal,
}) {
  const [sendToRecordingChannel, setSendToRecordingChannel] = useState(false);
  const [activeTab, setActiveTab] = useState('details');

  const handleToggleChange = () => {
    setSendToRecordingChannel(!sendToRecordingChannel);
    handleChange({ target: { name: 'sendToRecordingChannel', value: !sendToRecordingChannel } });
  };
  
  if (!isModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-80 flex justify-center items-center !mt-0">
      <div className="relative bg-white p-6 rounded shadow-lg w-1/3">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">
          {isEditMode ? 'Edit Franchisee' : 'Create Franchisee'}
        </h2>
      </div>
      <div className="flex space-x-4  pb-6">
        <button 
          className={`px-4 py-2 text-sm font-semibold ${activeTab === 'details' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} 
          onClick={() => setActiveTab('details')}
        >
          Details
        </button>
        <button 
          className={`px-4 py-2 text-sm font-semibold ${activeTab === 'pipeline' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`} 
          onClick={() => setActiveTab('pipeline')}
        >
          Pipeline
        </button>
      </div>
      
      <form id="franchiseeForm" onSubmit={handleSubmit}>
        {activeTab === 'details' && (
        <div className="mb-4">
          <div className="grid grid-cols-2 gap-4">

            <div className='col-span-2'>
              <label className="block text-sm font-medium text-gray-700">
                Associated Client <span className="text-red-500">*</span>
              </label>

              {/*  should send back the assoc client id to add in the form  */}
              <ClientDropdown 
                client={editFranchisee?.assoc_client_type || null} 
                franchiseeID={editFranchisee?.id}
                onClientSelect={(selectedClient) =>
                  handleChange({
                    target: { name: 'assoc_client_type', value: selectedClient?.id || null }
                  })
                }
                />

              {!editFranchisee?.assoc_client_type && (
                <p className="text-red-500 text-sm mt-1">Associated Client is required.</p>
              )}
              
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Owner <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="owner"
                value={editFranchisee?.owner || ''}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
              {!editFranchisee?.owner && (
                <p className="text-red-500 text-sm mt-1">Owner is required.</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Owner Email<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="owner_email"
                value={editFranchisee?.owner_email || ''}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
              {!editFranchisee?.owner_email && (
                <p className="text-red-500 text-sm mt-1">Owner Email is required.</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Client Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={editFranchisee?.name || ''}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
              {!editFranchisee?.name && (
                <p className="text-red-500 text-sm mt-1">Client Name is required.</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                HubSpot API Key
              </label>
              <input
                type="text"
                name="hubspot_api_key"
                value={editFranchisee?.hubspot_api_key || ''}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Slack Channel ID <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="slackChannelID"
                value={editFranchisee?.slackChannelID || ''}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
              {!editFranchisee?.slackChannelID && (
                <p className="text-red-500 text-sm mt-1">
                  Slack Channel ID is required.
                </p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
              Recording Channel ID
              </label>
              <input
                type="text"
                name="recordingChannelID"
                value={editFranchisee?.recordingChannelID || ''}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
            {isEditMode && (
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Send All Recordings <span className='font-light'>(skip call duration filter)</span>
                </label>
                <button
                  type="button"
                  onClick={() =>
                    handleChange({
                      target: { name: 'send_all_recording', value: !editFranchisee?.send_all_recording },
                    })
                  }
                  className={`mt-1 relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none ${
                    editFranchisee?.send_all_recording ? 'bg-blue-600' : 'bg-gray-200'
                  }`}
                >
                  <span
                    className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${
                      editFranchisee?.send_all_recording ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
              </div>
            )}

            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700">Zips <span className='font-light'>(Separate values with a comma)</span></label>
              <textarea
                name="zips"
                value={editFranchisee?.settings?.zips || ''}
                onChange={handleChange}
                rows="9"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>

            <div className="absolute flex items-center top-7 right-6">
              <label className="text-sm font-medium text-gray-700 mr-2">
                Send Recording to TWS Channel
              </label>
              <button
                type="button"
                onClick={() =>
                  handleChange({
                    target: { name: 'isRedirected', value: !editFranchisee?.isRedirected },
                  })
                }
                disabled={!editFranchisee?.slackChannelID}
                className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none ${
                  editFranchisee?.isRedirected ? 'bg-blue-600' : 'bg-gray-200'
                } ${!editFranchisee?.slackChannelID ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                <span
                  className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${
                    editFranchisee?.isRedirected ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

          </div>
          </div>
        )}

        {activeTab === 'pipeline' && (
          <div className="grid grid-cols-2 gap-4">            
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Upcoming Project 
            </label>
            <input
              type="text"
              name="upcoming_project"
              value={editFranchisee?.pipeline_stages?.upcoming_project || ''}
              disabled={editFranchisee?.isCreatePipeline}
              onChange={handleChange}
              className={`mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${editFranchisee?.isCreatePipeline ? `opacity-50 cursor-not-allowed` : ''}`}
            />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700">
              Past Bid Date 
            </label>
            <input
              type="text"
              name="past_bid_date"
              value={editFranchisee?.pipeline_stages?.past_bid_date || ''}
               disabled={editFranchisee?.isCreatePipeline}
              onChange={handleChange}
              className={`mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${editFranchisee?.isCreatePipeline ? `opacity-50 cursor-not-allowed` : ''}`}
            />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700">
              Warm Lead 
            </label>
            <input
              type="text"
              name="warm_lead"
              value={editFranchisee?.pipeline_stages?.warm_lead || ''}
               disabled={editFranchisee?.isCreatePipeline}
              onChange={handleChange}
              className={`mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${editFranchisee?.isCreatePipeline ? `opacity-50 cursor-not-allowed` : ''}`}
            />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700">
              Hot Leads 
            </label>
            <input
              type="text"
              name="hot_lead"
              value={editFranchisee?.pipeline_stages?.hot_lead || ''}
               disabled={editFranchisee?.isCreatePipeline}
              onChange={handleChange}
              className={`mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${editFranchisee?.isCreatePipeline ? `opacity-50 cursor-not-allowed` : ''}`}
            />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700">
              Meetings Booked 
            </label>
            <input
              type="text"
              name="meeting_booked"
              value={editFranchisee?.pipeline_stages?.meeting_booked || ''}
               disabled={editFranchisee?.isCreatePipeline}
              onChange={handleChange}
              className={`mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${editFranchisee?.isCreatePipeline ? `opacity-50 cursor-not-allowed` : ''}`}
            />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700">
              Opportunities Fulfilled 
            </label>
            <input
              type="text"
              name="opp_fulfilled"
              value={editFranchisee?.pipeline_stages?.opp_fulfilled || ''}
               disabled={editFranchisee?.isCreatePipeline}
              onChange={handleChange}
              className={`mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${editFranchisee?.isCreatePipeline ? `opacity-50 cursor-not-allowed` : ''}`}
            />
          </div>

          {
            !isEditMode && (
              <div className="absolute flex items-center top-7 right-6">
              <label className="text-sm font-medium text-gray-700 mr-2">
                Automatically Create Pipeline Stages in HubSpot
              </label>
              <button
                type="button"
                onClick={() =>
                  handleChange({
                    target: { name: 'isCreatePipeline', value: !editFranchisee?.isCreatePipeline },
                  })
                }
                className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none ${
                  editFranchisee?.isCreatePipeline ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform ${
                    editFranchisee?.isCreatePipeline ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
            )
          }
          </div>
          
        )}

        <div className="flex justify-between items-center mt-4">
          {isEditMode && !editFranchisee?.deletedAt && (
            <button
              type="button"
              onClick={handleDelete}
              className="mr-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
              Delete
            </button>
          )}
          {isEditMode && editFranchisee?.deletedAt && (
            <button
              type="button"
              onClick={handleDelete}
              className="bg-hs-blue text-white px-4 py-2 rounded hover:bg-hs-dark-blue"
            >
              Restore
            </button>
          )}
          
          <div className="flex space-x-2 right-0">
            <button
              type="button"
              onClick={handleCloseModal}
              className="mr-2 bg-gray-300 text-gray-700 px-4 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Save
            </button>
          </div>
        </div>
        </form>
      </div>
    </div>
  );
}
